import create from "zustand";

interface CodeAndAreaProps {
  code: string;
  tamanhoAreaHa: number
}

interface ModalState {
  id?: string;
  names?: string[];
  isOpen: boolean;
  ordemServicoIdAndColor: { ordemServicoId: string; talhaoIds?: string[]; color: string; codesAndArea: CodeAndAreaProps[] };
  allCheckeds: boolean;
  hiddenCompleteds: boolean;
  hiddenBlockeds: boolean;
  operationName: string;
  checkedItems: Set<string>;

  setId: (args: string) => void;
  setNames: (args: string[]) => void;
  setIsOpen: (args: boolean) => void;
  setOrdemServicoIdAndColor: (args: any) => void;
  setAllCheckeds: (args: boolean) => void;
  setHiddenCompleteds: (args: boolean) => void;
  setHiddenBlockeds: (args: boolean) => void;
  setOperationName: (args: string) => void;
  setCheckedItems: (updater: Set<string> | ((prev: Set<string>) => Set<string>)) => void;
}

const useModalOrdemServicoMatriz = create<ModalState>((set) => ({
  id: "",
  names: [],
  isOpen: false,
  ordemServicoIdAndColor: { ordemServicoId: "", talhaoIds: [], color: "", codesAndArea: [] },
  allCheckeds: false,
  hiddenCompleteds: false,
  hiddenBlockeds: false,
  operationName: "",
  checkedItems: new Set(),

  setId: (id) => {
    set(state => ({ id }));
  },
  setNames: (names) => {
    set(state => ({ names }));
  },
  setIsOpen: (isOpen) => {
    set(state => ({ isOpen }));
  },

  setOrdemServicoIdAndColor: (ordemServicoIdAndColor) => {
    set(state => ({ ordemServicoIdAndColor }));
  },

  setAllCheckeds: (allCheckeds) => {
    set(state => ({ allCheckeds }));
  },

  setHiddenCompleteds: (hiddenCompleteds) => {
    set(state => ({ hiddenCompleteds }));
  },

  setHiddenBlockeds: (hiddenBlockeds) => {
    set(state => ({ hiddenBlockeds }));
  },

  setOperationName: (operationName) => {
    set(state => ({ operationName }));
  },

  setCheckedItems: (updater) => {
    set((state) => {
      const newCheckedItems = typeof updater === "function"
        ? updater(state.checkedItems)
        : updater;
      return { checkedItems: newCheckedItems };
    });
  }
}));

export default useModalOrdemServicoMatriz;
